/*
 * Copyright (c) 2025. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import type { ChipProps } from '@mui/material';
import { overrideSx } from '../../styles';
import { LoadingChip } from '../buttons';
import { useFormContext } from './formContext';

interface Props extends Omit<ChipProps, 'onClick' | 'loading' | 'value' | 'variant'> {
  loading?: boolean;
  disableIfNotChanged?: boolean;
}

function SubmitChip({
  disabled,
  loading,
  label = 'Save',
  disableIfNotChanged = true,
  ...props
}: Readonly<Props>) {
  const appForm = useFormContext();

  return (
    <appForm.Subscribe
      selector={(state) => [state.isSubmitting, state.isFormValid, state.isDefaultValue]}
    >
      {([isSubmitting, isFormValid, isDefaultValue]) => {
        const buttonDisabled =
          disabled || !isFormValid || (disableIfNotChanged ? isDefaultValue : false);
        return (
          <LoadingChip
            {...props}
            loading={(isSubmitting || loading) ?? false}
            onClick={appForm.handleSubmit}
            label={label}
            disabled={buttonDisabled}
            sx={(t) =>
              overrideSx(
                {
                  bgcolor: t.palette.mode === 'dark' ? 'primary.light' : 'primary.dark',
                  color: t.palette.getContrastText(
                    t.palette.mode === 'dark' ? t.palette.primary.light : t.palette.primary.dark,
                  ),
                },
                t,
                props.sx,
              )
            }
          />
        );
      }}
    </appForm.Subscribe>
  );
}

export default SubmitChip;
